import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input, message, Popconfirm, Space, Spin, Table } from "antd";
import { productCategoryApi } from "api/product-category.api";
import { Pagination } from "components/Pagination";
import React, { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { QueryParam } from "types/query";
import { ProductCategory } from "types/product-category";
import { $url } from "utils/url";
import { ProductCategoryModal } from "../ProductCategoryModal";
// import { StaffModal } from "./components/StaffModal";

const { ColumnGroup, Column } = Table;

export const ProductCategoryTab = ({ shopId }: { shopId: number }) => {
  const [query, setQuery] = useState<QueryParam>({
    page: 1,
    limit: 50,
    search: "",
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ProductCategory[]>([]);
  const [total, setTotal] = useState(0);
  const [visibleModal, setVisibleModal] = useState(false);
  const [selectedProductCategory, setSelectedProductCategory] = useState<
    Partial<ProductCategory>
  >({});
  const [modalStatus, setModalStatus] = useState<ModalStatus>("create");

  useEffect(() => {}, []);

  useEffect(() => {
    if (shopId) {
      fetchData();
    }
  }, [query]);

  useEffect(() => {
    if (shopId) {
      query.page = 1;
      query.search = "";
      setQuery({
        ...query,
      });
    }
  }, [shopId]);

  const fetchData = async () => {
    setLoading(true);
    const res = await productCategoryApi.findAll({
      ...query,
      shopId,
    });
    setLoading(false);
    setData(res.data.productCategories);
    setTotal(res.data.total);
  };

  const handleDelete = async (row: ProductCategory) => {
    setLoading(true);
    try {
      await productCategoryApi.delete(row.id);
      fetchData();
      message.success("Xóa thành công");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="filter-container">
        <Space>
          <div className="filter-item">
            <label htmlFor="">Tìm kiếm</label>
            <Input
              onKeyDown={(ev) => {
                if (ev.code == "Enter") {
                  setQuery({ ...query });
                }
              }}
              size="middle"
              onChange={(ev) => {
                query.search = ev.currentTarget.value;
              }}
              placeholder="Tìm kiếm"
            />
          </div>

          <div className="filter-item btn">
            <Button
              onClick={fetchData}
              type="primary"
              icon={<SearchOutlined />}
            >
              Search
            </Button>
          </div>

          <div className="filter-item btn">
            <Button
              onClick={() => {
                setVisibleModal(true);
                setModalStatus("create");
                setSelectedProductCategory({});
              }}
              type="primary"
              icon={<PlusOutlined />}
            >
              Tạo mới danh mục
            </Button>
          </div>
        </Space>
      </div>

      <Spin spinning={loading}>
        <Table pagination={false} rowKey="id" dataSource={data}>
          <Column title="Tên danh mục" dataIndex="name" key="name" />

          <Column
            title="Giới thiệu"
            dataIndex="description"
            key="description"
          />

          <Column title="Vị trí" dataIndex="position" key="position" />

          <Column
            title="Thao tác"
            key="action"
            render={(text, record: ProductCategory) => (
              <span>
                <Space>
                  <Button
                    type="primary"
                    onClick={() => {
                      setSelectedProductCategory(record);
                      setVisibleModal(true);
                      setModalStatus("update");
                    }}
                  >
                    Cập nhật
                  </Button>

                  <Popconfirm
                    placement="top"
                    title="Xác nhận xóa danh mục này"
                    cancelText="Đóng"
                    okText="Xóa"
                    onConfirm={() => handleDelete(record)}
                  >
                    <Button danger>Xóa</Button>
                  </Popconfirm>
                </Space>
              </span>
            )}
          />
        </Table>

        <Pagination
          currentPage={query.page}
          total={total}
          onChange={({ limit, page }) => {
            query.page = page;
            query.limit = limit;
            setQuery({ ...query });
          }}
        />
      </Spin>

      <ProductCategoryModal
        shopId={shopId}
        onSubmitOk={fetchData}
        onClose={() => setVisibleModal(false)}
        visible={visibleModal}
        productCategory={selectedProductCategory}
        status={modalStatus}
      />
    </div>
  );
};
